<template>
  <div class="addrole">
    <div class="title">
      角色管理 <span>添加角色</span>
    </div>
    <div class="main">
      <div class="addRoleInfo">添加角色</div>
      <div class="roleContent">
        <div class="rolelist">
          <label for="roleName"><span>*</span>角色名称</label>
          <el-input v-model="roleName"
                    size="small"></el-input>
        </div>
        <!-- <div class="rolelist">
                    <label for="updateStatus">
                        <span>*</span>角色类型
                    </label>
                    <div class='roleRadio'>
                        <el-radio v-model="radio" label="0">管理角色</el-radio>
                        <el-radio v-model="radio" label="1">分配角色</el-radio>
                    </div>
                </div> -->
        <div class="rolelist">
          <label for="roleCompany"><span>*</span>归属公司</label>
          <el-select v-model="company"
                     size="small"
                     @change="handleCompanyChange(company)">
            <el-option v-for="item in companyList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="rolelist">
          <label for="department"><span>*</span>归属部门</label>
          <el-select v-model="officeid"
                     size="small"
                     :disabled="department">
            <el-option v-for="item in officeList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="rolelist">
          <label for="permission">菜单权限</label>
          <div class="permission">
            <div v-for="(item, index) in lists"
                 :key="index"
                 class="check-group">
              <div class="menutitle">
                <el-checkbox v-model="checkAll[index]"
                             @change="handleAllChange(checkAll[index],item,index)">
                </el-checkbox>
                <span class="menu_showoff">{{item.name}}</span>
              </div>
              <el-collapse-transition>
                <el-checkbox-group v-model="checkList[index]"
                                   @change="handleChange">
                  <el-checkbox v-for="data in item.children"
                               :key="data.name"
                               :label="data.id">
                    {{ data.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-collapse-transition>
            </div>
          </div>
        </div>
        <div class="rolelist">
          <label for="remark">备注</label>
          <el-input type="textarea"
                    :autosize="{ minRows: 3, maxRows: 8}"
                    v-model="remarks"></el-input>
        </div>
        <div class="roleBtn">
          <button class="save"
                  @click="handleAddRoleClick">
            保存
          </button>
          <button @click="handleCancelClick"
                  class="cancel">
            取消
          </button>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getmenulist,
  addMenulist,
  getUpdateMenu,
  saveUpdateMenu
} from 'apis/index'
export default {
  name: 'addrole',
  data () {
    return {
      id: '',
      radio: '0',
      remarks: '',
      roleName: '',
      department: true,
      status: '',
      menuids: '',
      company: '',
      companyList: [],
      officeid: '',
      officeList: [],
      sysoffice: [],
      checkAll: [],
      checkList: [],
      lists: []
    }
  },

  methods: {
    getmenu (id) { // 获取信息
      if (id) { // 修改
        getUpdateMenu({
          roleId: id
        }).then(res => {
          if (res.data.code === 200) {
            this.department = false
            this.lists = res.data.data.role
            this.companyList = res.data.data.sysOfficeList
            let secRole = res.data.data.secRole
            this.roleName = secRole.name
            this.company = secRole.companyId
            this.officeid = secRole.departmentId
            this.remarks = secRole.remarks
            this.companyList.forEach(element => {
              if (this.company === element.id) {
                this.officeList = element.officeList
              }
            })
            for (const i in this.lists) {
              this.lists[i].show = false
              this.$set(this.checkList, i, [])
              if (this.lists[i].children) {
                for (let j = 0; j < this.lists[i].children.length; j++) {
                  if (this.lists[i].children[j].checked) {
                    // 不能set，下面全选要比较checkList和list的对应children的长度
                    this.checkList[i].push(this.lists[i].children[j].id)
                  }
                }
              }
              // 判断是否全选
              const checked = this.lists[i].children && this.lists[i].children.length > 0 ? this.lists[i].children.length === this.checkList[i].length : false
              this.$set(this.checkAll, i, checked)
            }
          }
        })
      } else {
        getmenulist().then(res => {
          if (res.data.code === 200) {
            this.lists = res.data.data.role
            this.companyList = res.data.data.sysoffice
            for (const i in this.lists) {
              this.lists[i].show = false
              this.$set(this.checkList, i, [])
              if (this.lists[i].children) {
                for (let j = 0; j < this.lists[i].children.length; j++) {
                  if (this.lists[i].children[j].checked) {
                    // 不能set，下面全选要比较checkList和list的对应children的长度
                    this.checkList[i].push(this.lists[i].children[j].id)
                  }
                }
              }
              // 判断是否全选
              const checked = this.lists[i].children && this.lists[i].children.length > 0 ? this.lists[i].children.length === this.checkList[i].length : false
              this.$set(this.checkAll, i, checked)
            }
          }
        })
      }
    },
    handleAddRoleClick () { // 添加
      this.menuids = ''
      this.checkList.forEach((element, index) => {
        // console.log(element)

        if (element.length) {
          element.forEach(childElement => {
            this.menuids += childElement + ','
          })
          this.menuids += this.lists[index].id + ','
        }
      })
      this.menuids = this.menuids.slice(0, -1)
      if (!this.roleName | !this.company | !this.officeid | !this.menuids) {
        this.$message.error('*为必选内容')
      } else {
        if (this.id) { // 修改
          saveUpdateMenu({
            id: this.id,
            name: this.roleName,
            menus: this.menuids,
            companyId: this.companyId,
            departmentId: this.officeid,
            remarks: this.remarks
          }).then(res => {
            if (res.data.code === 200) {
              this.$router.push({ path: '/system/role' })
            }
          })
        } else { // 添加
          addMenulist({
            name: this.roleName,
            companyId: this.company,
            departmentId: this.officeid,
            menus: this.menuids,
            remarks: this.remarks
          }).then(res => {
            if (res.data.code === 200) {
              this.$router.push({ path: '/system/role' })
            }
          })
        }
      }
    },
    handleCompanyChange (value) {
      this.department = false
      this.officeid = ''
      this.companyList.forEach(element => {
        if (element.id === value) {
          this.officeList = element.officeList
        }
      })
    },
    handleCancelClick () { // 取消添加/修改
      this.$router.push({ path: '/system/role' })
    },
    handleChange (val) {
      // console.log(val)

      // 判断是否全选
      for (const i in this.lists) {
        const checked = this.lists[i].children && this.lists[i].children.length > 0 ? this.lists[i].children.length === this.checkList[i].length : false
        this.$set(this.checkAll, i, checked)
      }
    },
    // 全选
    handleAllChange (val, item, index) {
      if (!val) {
        this.$set(this.checkList, index, [])
      } else {
        if (this.lists[index].children) {
          for (let j = 0; j < this.lists[index].children.length; j++) {
            this.$set(this.checkList[index], j, this.lists[index].children[j].id)
          }
        }
      }
    }

  },

  created () {
    this.id = this.$route.query.company ? this.$route.query.company : ''
    this.getmenu(this.id)
  }

}
</script>
<style lang="stylus">
.addrole
  position absolute
  top 0px
  bottom 20px
  left 20px
  right 0px
  z-index 1
  padding-right 20px
  overflow-y auto
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 57px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #fff
    padding-bottom 110px
    .addRoleInfo
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../assets/images/03/add_icon.png') no-repeat center left 15px
    .roleContent
      width 100%
      height calc(100% - 62px)
      padding-top 14px
      border-top 1px solid #CFD5DC
      .rolelist
        margin-top 26px
      .rolelist>label
        width 154px
        float left
        line-height 32px
        text-align right
        font-size 12px
        color #5E656F
        span
          color #FF344A
        .tar
          width 50px
          height 30px
          float right
          text-align left
          line-height 15px
        .tarIcon
          width 5px
          height 30px
          float right
          line-height 15px
      .el-input
        width 220px
        margin-left 12px
      .el-textarea
        width 475px
        margin-left 12px
      .roleRadio
        height 30px
        .el-radio
          margin-left 20px
          width 80px
          .el-radio__label
            color #212832
      .permission
        width 660px
        min-height 580px
        overflow hidden
        margin-left 166px
        .menutitle
          width 100%
          height 44px
          line-height 44px
          background #E7F0F8
          margin-top 10px
          .el-checkbox
            width auto
            float left
            cursor default
          .menu_showoff
            display inline-block
            cursor pointer
            margin-left 10px
            height 44px
            padding-right 20px
            background url('../../../assets/images/08/xiala_n_icon.png') no-repeat center right
        label
          line-height 44px
          text-align left
          font-size 12px
          margin-left 20px
          color #212832
          span
            color #5E656F
        .el-checkbox
          width 128px
        .el-collapse-item__content
          height 44px
          padding-bottom 0px
          font-size 13px
          color #303133
          line-height 44px
          box-sizing border-box
          border-bottom 1px dashed #ccc
        .el-collapse-item__arrow
          float none
          margin-left 5px
      .updateTar
        position relative
        .updateFileBtn
          position absolute
          width 112px
          height 30px
          cursor pointer
          background #00D5B9
          text-align center
          text-indent 2em
          line-height 32px
          left 443px
          top 0px
          border-radius 3px
          background url('../../../assets/images/07/wenjian_icon.png') no-repeat center left 20px #00D5B9
          size12()
          color #FFFFFF
          .updateBtn
            position absolute
            top 0px
            left 0px
            cursor pointer
            opacity 0
            right 0px
            bottom 0px
            overflow hidden
      .roleBtn
        margin-left 153px
        margin-top 70px
        button
          padding 4px 26px
          cursor pointer
          margin 0 20px
          background #FFFFFF
          border-radius 3px
          border 1px solid #CFD5DC
          &:hover
            background #1B88EE
            color #fff
            border 1px solid #1B88EE
</style>
